<div class='container-lg'>
  <div class='list-container mt-2'>
    <h2 class='card-title'
        *ngIf='loaded'>Organization Details</h2>
    <h2 class='card-title'
        *ngIf='!loaded'>Loading Organization Details...</h2>
    <div class='row mb-3'>
      <div class='col-6 col-md-4 col-xl-3'>
        <small class='col-12 pl-0'>ORG. NAME</small>

        <div [hidden]='!loaded' *ngIf='!isEditingOrgName' class='text-capitalize font-16 pointer-cursor'
             (click)='enableOrgEdit()'>{{org?.name}}</div>
        <input id='orgNameInput' *ngIf='isEditingOrgName' class='form-control col-12 pl-0' [value]='org?.name'
               (keyup.enter)='editOrgName($event)'
               (blur)='editOrgName($event)'/>
      </div>
      <div class='col-6 col-md-4 col-xl-3'>
        <small>ORG. ID</small>
        <div [hidden]='!loaded' class='font-16'>
          {{org?.id}}

        </div>
      </div>
      <div class='col-6 col-md-4 col-xl-3'>

        <small>NUMBER OF USERS</small>
        <div class='text-capitalize font-16'>

          {{org?.numberOfUsers}}
        </div>


      </div>

      <button class='btn btn-link' [hidden]='!loaded' *ngIf='org?.id !== "0" && org?.active'
              data-toggle='modal' data-target='#deactivationModal'>
        <small>Deactivate Org
        </small></button>
      <button class='btn btn-link' [hidden]='!loaded' *ngIf='org?.id !== "0" && !org?.active'
              (click)='editOrgActivation(org)'>
        <small>Activate Org
        </small></button>
    </div>

    <div class='row mb-3' [hidden]='!loaded'>
      <h2 class='col-12'>Enabled Test Types</h2>
      <div class='col-md-3 col-12'>
        <form [formGroup]='form' *ngIf='form' novalidate class='d-flex flex-column'>
          <div *ngFor='let testType of testTypes'>
            <label class='d-flex justify-content-between'>
              <div class='d-flex align-items-center'>
                <input type='checkbox' [disabled]='this.hiddenTests && this.hiddenTests.includes(testType.value)'
                       [checked]='org?.enabledTests?.includes(testType.value)' [value]='testType.value'
                       (change)='onCheckboxChange($event)' class='mr-1'/>
                <span [ngClass]='{"text-muted":this.hiddenTests.includes(testType.value)}'>{{testType.name}}</span>
              </div>
              <button class='btn btn-link p-0' (click)='hideTestType(testType.value)'>
                <small>{{this.hiddenTests.includes(testType.value) ? "Show" : "Hide"}}</small></button>
            </label>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div *ngFor='let user of this.org?.users' class='list-container mt-2 row mx-0' (click)='navigateToUser(user)'>
    <div class='col-6 col-md-4 col-xl-3 fit-content'>
      <small>UID</small>

      <div [hidden]='!loaded' class='font-16'>
        {{user.userRecord?.uid}}
      </div>
    </div>
    <div class='col-6 col-md-4 col-xl-3 fit-content'>
      <small>DISPLAY NAME</small>
      <div [hidden]='!loaded' class='font-16'>
        {{user.userData?.displayName || "No Display Name"}}

      </div>
    </div>
    <div class='col-6 col-md-4 col-xl-3 fit-content'>

      <small>EMAIL</small>
      <div class='font-16'>

        {{user.userRecord?.email || "No Email"}}
      </div>


    </div>
    <p class='text-info mt-2 col-12' role='alert' *ngIf='user.userData?.customTestsEnabled'>
      User has custom test settings
    </p>
  </div>
</div>

<!-- Modal -->
<div class='modal fade' id='deactivationModal' tabindex='-1' role='dialog' aria-labelledby='modalTitle'
     aria-hidden='true'>
  <div class='modal-dialog' role='document'>
    <div class='modal-content'>
      <div class='modal-header'>
        <h5 class='modal-title' id='modalTitle'>Deactivate {{org?.name}}</h5>
        <button type='button' class='close' data-dismiss='modal' aria-label='Close'>
          <span aria-hidden='true'>&times;</span>
        </button>
      </div>
      <div class='modal-body'>
        {{"Are you sure you want to deactivate " + org?.name + "? Users will no longer be able to login."}}
      </div>
      <div class='modal-footer'>
        <button type='button' class='btn btn-secondary' data-dismiss='modal'>Close</button>
        <button type='button' class='btn btn-primary' data-dismiss='modal' (click)='editOrgActivation(org)'>Deactivate
        </button>
      </div>
    </div>
  </div>
</div>
